/**
 * @generated SignedSource<<f623be7754bf67dfb112d634b561d58e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateCurrentUserInput = {
  displayName?: string | null | undefined;
};
export type UpdateCurrentUserMutation$variables = {
  input: UpdateCurrentUserInput;
};
export type UpdateCurrentUserMutation$data = {
  readonly updateCurrentUser: {
    readonly displayName: string | null | undefined;
    readonly email: string | null | undefined;
    readonly name: string | null | undefined;
    readonly user: {
      readonly displayName: string | null | undefined;
      readonly id: string;
    };
  };
};
export type UpdateCurrentUserMutation = {
  response: UpdateCurrentUserMutation$data;
  variables: UpdateCurrentUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CurrentUser",
    "kind": "LinkedField",
    "name": "updateCurrentUser",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCurrentUserMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpdateCurrentUserMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "d02683f4f2882cd35b99783dd047811a",
    "id": null,
    "metadata": {},
    "name": "UpdateCurrentUserMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateCurrentUserMutation(\n  $input: UpdateCurrentUserInput!\n) {\n  updateCurrentUser(input: $input) {\n    displayName\n    email\n    name\n    user {\n      displayName\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aba08c29a14fc66ca6f466c18ee6604b";

export default node;
